export default {
    SET_USERINFO: (state, value) => {           // 存储用户信息
        state.userInfo = value;
        sessionStorage.setItem('userInfo', JSON.stringify(value));
    },
    DELETE_USERINFO: (state) => {               // 删除用户信息
        state.userInfo = null;
        sessionStorage.removeItem('userInfo');
    },
    SET_FAMILY: (state, value) => {           // 存储家人信息
        state.family = value;
        sessionStorage.setItem('family', JSON.stringify(value));
    },
    DELETE_FAMILY: (state) => {               // 删除家人信息
        state.family = null;
        sessionStorage.removeItem('family');
    },
    SET_TOKEN: (state, value) => {           // 存储token
        state.token = value;
        sessionStorage.setItem('token', JSON.stringify(value));
    },
    DELETE_TOKEN: (state) => {               // 删除token
        state.token = null;
        sessionStorage.removeItem('token');
    }
}


// WEBPACK FOOTER //
// ./src/vuex/mutations/mutations.js